import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { fremontConfig } from "./data";

export default function FremontPage() {
  return <CityPageTemplate config={fremontConfig} />;
}